import React, {useEffect, useState} from 'react';
import PropTypes from 'prop-types';
import {Link} from 'react-router-dom';
import {sortBy, map} from 'lodash';
import styles from './styles.module.scss';

const propTypes = {
  scholarshipProgram: PropTypes.string,
  sponsorId: PropTypes.string,
  globalItems: PropTypes.bool,
  fetchTimeSensitiveItemTypes: PropTypes.func,
};

const List = (props) => {
  const [timeSensitiveItemTypes, setTimeSensitiveItemTypes] = useState([]);
  const {scholarshipProgram, sponsorId, fetchTimeSensitiveItemTypes, globalItems} = props;

  useEffect(() => {
    fetchTimeSensitiveItemTypes(sponsorId, scholarshipProgram, globalItems).then((response) => {
      setTimeSensitiveItemTypes(sortBy(response, ['title']));
    });
  }, [sponsorId, scholarshipProgram]);

  return (
    <>
      <h4 className={styles.header}>
        {!sponsorId ? 'Global ' : ''}Time Sensitive Item Types ({timeSensitiveItemTypes.length}{' '}
        Results)
      </h4>
      {map(timeSensitiveItemTypes, (type) => (
        <div key={`${type._id}`} className={styles.listItemContainer}>
          <Link
            to={`/admin/tools/time-sensitive-item-types/${type._id}`}
            className={styles.listItem}
          >
            {type.title}
          </Link>
        </div>
      ))}
    </>
  );
};

List.propTypes = propTypes;

export default List;
